module.exports = __webpack_public_path__ + "static/media/skill_node.6dcf6999.png";